import AWS, { Config } from 'aws-sdk';
import {
  CognitoUserPool,
  CognitoUser
} from 'amazon-cognito-identity-js';

function forgot(username, config) {
  const userPool = new CognitoUserPool({
    UserPoolId: config.UserPoolId,
    ClientId: config.ClientId,
  });

  const userData = {
    Username : username,
    Pool : userPool
  };

  Config.region = config.region;
  const cognitoUser = new CognitoUser(userData);
  const prom = new Promise((resolve, reject) => {
    cognitoUser.forgotPassword({
      onSuccess: (result) => { resolve(result); },
      onFailure: (error) => { reject(error); },
    });
  });
  return prom;
}

export default function forgotPassword(username, config) {
  return dispatch => dispatch({
    type: 'FORGOT_PASSWORD_FETCH',
    payload: forgot(username, config)
  });
}



// WEBPACK FOOTER //
// ./src/actions/forgotPassword.js